export const myFetch = (input, init) => fetch(input, init);
export { EventEmitter } from 'events';
export { LocalAbortController } from './LocalAbortController';
